import React from 'react';

function getId (encoder) {
    return 'encoder-preview-' + encoder.encoderID
}

class EncoderPreview extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            jwplayerError: false
        }
    }

    componentDidMount() {
        this.initialize();
    }

    componentWillUnmount() {
        this.destroy();
    }

    destroy () {
        try {
            var videoPlayer = window.jwplayer(getId(this.props.encoder));

            videoPlayer.remove();
        } catch (e) {
            console.warn(this.props.parameters, 'Player Destroy Failure', e);
        }
    }

    initialize () {
        var { encoder } = this.props;
        let self = this;

        var stream = (encoder.live247URI) ?
            encoder.live247URI :
            encoder.previewURI;

        var setup = {
            abouttext: "Video streaming services provided by Invintus Media, Inc.",
            aboutlink: "https://www.invintus.com",
            hlshtml: true,
            width: '100%',
            sources: [{
                file: stream
            }]
        };


        var videoPlayer = jwplayer(getId(this.props.encoder));
        videoPlayer.setup(setup);

        videoPlayer.on('setupError', error => {
            self.setState({
                jwplayerError: error
            })
        })
    }

    render () {
        if (!!this.state.jwplayerError) {
            console.warn('metadata/components/encoders/children/EncoderPreview->jwplayerError', this.state.jwplayerError)
        }
        return <div className="col-md-3">
            <div id={getId(this.props.encoder)}/>
        </div>;
    }
}

export default EncoderPreview;
